// src/components/categories/Table/CategoriesTableRow.jsx
import React from "react";
import { TableRow, TableCell, IconButton, Checkbox, Chip, Avatar } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

const CategoriesTableRow = ({
    category,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false
}) => {
    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(category?.id);
    const imageUrl = category?.image?.url || category?.image?.preview || null;

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, category?.id)}
                    inputProps={{ "aria-labelledby": `category-${category?.id}` }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, category);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
            <TableCell>{serial}</TableCell>
            <TableCell>
                <Avatar
                    src={imageUrl}
                    alt={category?.name?.en || "Category"}
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 1,
                        bgcolor: isDark ? "rgba(59,130,246,0.2)" : "rgba(59,130,246,0.1)",
                    }}
                >
                    {!imageUrl && <DirectionsBusIcon />}
                </Avatar>
            </TableCell>
            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {category?.name?.ar || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {category?.name?.en || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {category?.parent?.name?.ar || category?.parent?.name?.en || "-"}
            </TableCell>

            <TableCell>
                <Chip
                    label={category?.status ? "Active" : "Inactive"}
                    color={category?.status ? "success" : "default"}
                    size="small"
                    sx={{
                        fontSize: "0.75rem",
                        fontWeight: 500,
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, category);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default CategoriesTableRow;
